<template>
   <div class="basic-block block-banners" :style="styles">
    <div class="banner-wrap">
      <a href="/2023_luck" @click.prevent="onBannerClick" class="banner">
        <img src="/static/img/recommend/lp/banner/yearluck2023.png" alt="2023年の運勢">
      </a>
      <img src="/static/img/recommend/lp/kurenotori/banner2_lead.png" alt="自分や家族、気になるあの人の運勢も!" class="fukidashi">
      <p class="banner__text"><b>{{ counselorName }}ほか、人気占い師の運勢鑑定が<br><em>約50％オフで占える！</em></b></p>
      <lp-base-button
          label="登録して占う"
          design="fill"
          :color-scheme="colorScheme"
          @clicked="clicked"
        />
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockBanner2',
  components: {
   LpBaseButton
  },
  props: {
    bannerPos: {
      type: String,
      default: '',
    },
    gaEventCateg: {
      type: String,
      default: 'uranaitv-2022unsei-banner'
    },
    lpId: {
      type: Number,
      default: 0
    },
    campaign: {
      type: String,
      default: 'LINE',
    },
    caption: String,
    hasCaption: {
      type: Boolean,
      default: false,
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return null
      }
    },
     subscUrl: String,
     page: {
      type: String,
      default: '',
     },
  },
  data() {
    return {
      // 親コンポーネントでも showBanner で表示・非表示を変えられるけど、
      // ここだと一括で切り替えられるので、応急処置用
      show: true,
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': !!this.colorScheme.keyColor ? this.colorScheme.keyColor : '#142254',
      }
    },
    counselorName(){
      return !!this.targetInfo ? this.targetInfo.name : '暮れの酉'
    }
  },
  methods: {
    onBannerClick(e){
      let param = {
        'event_category': `LP${this.lpId}${this.page}-${this.gaEventCateg}`,
      }
      if (this.bannerPos) {
        param.event_label = this.bannerPos
      }
      window.gtag('event', 'click', param)
      location.href = this.$handoverParams(e.currentTarget.href)
    },
    clicked() {
      let param = {
        'event_category': `LP${this.lpId}${this.page}-subsc-button`,
      }
      if (this.bannerPos) {
        param.event_label = this.bannerPos
      }
      window.gtag('event', 'click', param);
      location.href = this.$handoverParams(this.subscUrl)
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
.lp-child-base{
  .block-banners {
    background: #fff;
    padding-top: 60px;
    .banner {
      display: block;
      margin: 0 auto 24px;
      > img {
        max-width: 100%;
        vertical-align: middle;
      }
    }
    .fukidashi {
      display: block;
      width: 88%;
      max-width: 350px;
      margin: 0 auto 16px;
    }
    .banner__text {
      font-weight: 600;
      font-size: Min((16 / 375) * 100vw, 16 * 1.3px );
      line-height: 1.31;
      text-align: center;
      margin: 0 auto 24px;
      b {
        background: linear-gradient(0deg, #FFEF6B 8px, transparent 8px);
      }
      em {
        font-size: Min((26 / 375) * 100vw, 26 * 1.3px );
        font-style: normal;
      }
    }
    .baseButton {
      width: 72%;
      max-width: 340px;
      min-width: 270px;
      margin: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/BlockBanner2.vue